import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { incomePaymentDetailsLabels } from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { ITFLSAction } from "../../Actions/ITFLSAction";
import IncomePayment from "./IncomePayment";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    customerId: number;
}

interface IIncomePaymentDetailsState {
    assets: any;
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        const { data } = this.props;
        // Post income amendment instruction
        const id = getQueryParameters()["id"];
        ITFLSAction.createIncomeAmendmentInstructions(data, id, this.props.customerId);
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                <h2>Income payment details</h2>
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={incomePaymentDetailsLabels.needToProvideAnIncome}
                    selected={data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        if (!v) {
                            onChange(
                                setValueByKey(data, "Contribution.DrawdownModel.Income.IncomePaymentAllocations", [])
                            );
                        }
                        onChange(
                            setValueByKey(data, "Contribution.DrawdownModel.Income.TaxableIncomeRequiredInAddition", v)
                        );
                    }}
                />
                {data?.Contribution?.DrawdownModel &&
                    data?.Contribution?.DrawdownModel?.DrawdownType !== DrawdownType.Regular && (
                        <>
                            {data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition && (
                                <>
                                    <IncomePayment
                                        data={data?.Contribution}
                                        onChange={(changes) => {
                                            this.onDataChange(onChange, changes, data, "Contribution");
                                        }}
                                        onRef={(ref) => this.appendChild(ref)}
                                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                    />
                                </>
                            )}
                        </>
                    )}
                <IncomeBankDetails
                    data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                    onChange={(value) => {
                        onChange(
                            setValueByKey(data, "Contribution.DrawdownModel.Income.IncomePaymentAllocations", value)
                        );
                    }}
                    onRef={(ref) => this.appendChild(ref)}
                    allBankAccounts={data?.AllBankAccounts}
                    bankAccountInstructions={data?.BankAccountInstructions}
                    showPropotionOfIncome={
                        data?.Contribution?.DrawdownModel?.Income?.TaxableIncomeRequiredInAddition == true
                    }
                    showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                />
            </>
        );
    }
}
